import { render, staticRenderFns } from "./IconSort.vue?vue&type=template&id=0171b8ce&scoped=true&"
import script from "./IconSort.vue?vue&type=script&lang=js&"
export * from "./IconSort.vue?vue&type=script&lang=js&"
import style0 from "./IconSort.vue?vue&type=style&index=0&id=0171b8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171b8ce",
  null
  
)

export default component.exports